import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=a95acf5a"
import script from "./Activities.vue?vue&type=script&lang=ts"
export * from "./Activities.vue?vue&type=script&lang=ts"
import style0 from "./Activities.vue?vue&type=style&index=0&id=a95acf5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports